import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { BsBoxArrowUpRight } from "react-icons/bs";
import { useTranslation } from "react-i18next";

function BlogCard(props) {
  const { i18n } = useTranslation();
  const lang = i18n.language.split("-")[0];

  // Remove HTML and markdown, truncate to 150 characters
  const cleanText = props.description
    ?.replace(/<[^>]*>/g, "") // Remove HTML tags
    .replace(/\*\*(.+?)\*\*/g, "$1") // Remove **bold**
    .replace(/\*(.+?)\*/g, "$1") // Remove *italic*
    .replace(/`(.+?)`/g, "$1") // Remove `code`
    .replace(/\[(.+?)\]\(.+?\)/g, "$1") // Remove [links](url)
    .replace(/#{1,6}\s/g, "") // Remove # headers
    .trim();

  const truncatedDesc =
    cleanText?.length > 150 ? cleanText.substring(0, 150) + "..." : cleanText;

  return (
    <Card
      className="project-card-view"
      style={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      {props.imgPath && (
        <Card.Img
          variant="top"
          src={props.imgPath}
          alt="card-img"
          style={{ height: "200px", objectFit: "cover" }}
        />
      )}
      <Card.Body style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Card.Title style={{ textAlign: "center", minHeight: "3em" }}>
          {props.title}
        </Card.Title>
        <Card.Text style={{ textAlign: "justify", flex: 1 }}>
          {truncatedDesc}
        </Card.Text>
        <div style={{ marginTop: "auto", paddingTop: "15px" }}>
          <Button
            variant="primary"
            as={Link}
            to={props.link}
            className="w-100"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <BsBoxArrowUpRight /> {lang === "uz" ? "Batafsil" : "Read More"}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}

export default BlogCard;
